<template>
  <div id="auth" v-if="showUsernameInput || showPasswordInput">
    <h1>{{ room.name }}
      <img v-if="room.hasPassword" src="../assets/icons/lock2.svg"/>
      <span v-if="room.maxParticipants != null"> (up to {{ room.maxParticipants }} <img v-if="room.maxParticipants != null && room.maxParticipants < 50" src="../assets/icons/participants2.svg"/>)</span></h1>
    <p>{{ errorMessage }}</p>
    <form @submit.prevent="checkButtonInput(passInput, usernameInput, room)">
      <input
        v-if="showUsernameInput"
        type="text"
        v-model="usernameInput"
        placeholder="Set username"
      />
      <input
        v-if="showPasswordInput"
        type="password"
        v-model="passInput"
        placeholder="Enter password"
      />
      <button type="submit">Submit</button>
    </form>
    <div id="limit-notification" v-if="limitNotification">
      <p>This room has reached max&shy;i&shy;mum capaci&shy;ty.<router-link to="/"> Choose another room or</router-link> try again later!</p>
    </div>
    <router-link id="back-to-list" to="/" tag="button">Back to Roomlist</router-link>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DirectRoomLogin",
  data() {
    return {
      room: null,
      passRequired: false,
      passInput: null,
      usernameInput: null,
      errorMessage: "",
      showUsernameInput: null,
      showPasswordInput: null,
    };
  },
  created() {
    // 1. getting the room (meta) information
    this.getRoomData();
  },
  computed: {
    username() {
      return this.$store.state.username;
    },
    limitNotification() {
      return this.$store.state.limitNotification;
    },
  },
  methods: {
    async getRoomData() {
      let room = await axios
        .get(
          `https://api.enter.hetnieuweinstituut.nl/rooms?slug=${this.$route.params.slug}`
        )
        .then((res) => {
          return res.data[0];
        });
      this.room = room;
      // 2. when ready, displaying the input fields that are necessary to access the room
      this.displayInputFields();
    },
    displayInputFields() {
      // little bit hacky to have the switch statement with 'true', but making this into and if/else statement would be even more complicated to read
      switch (true) {
        case this.username === null && this.room.hasPassword == false:
          this.showUsernameInput = true;
          this.showPasswordInput = false;
          break;
        case this.username === null && this.room.hasPassword == true:
          this.showUsernameInput = true;
          this.showPasswordInput = true;
          break;
        case this.username != null && this.room.hasPassword == false:
          this.showUsernameInput = false;
          this.showPasswordInput = false;
          this.openRoom(this.room);
          break;
        case this.username != null && this.room.hasPassword == true:
          this.showUsernameInput = false;
          this.showPasswordInput = true;
          break;
        default:
      }
    },
    checkButtonInput(passInput, usernameInput, room) {
      switch (true) {
        case this.username === null && room.hasPassword === false:
          this.submitUsername(usernameInput, room).then((r) => {
            if (r == "success") {
              this.openRoom(room);
            }
          });
          break;
        case this.username === null && room.hasPassword === true:
          this.passRequired = true;
          this.submitUsername(usernameInput, room).then((r) => {
            if (r == "success") {
              // window.console.log("username success");
              this.submitPassword(passInput, room).then((r2) => {
                if (r2 == "success") {
                  // window.console.log("password success");
                  this.openRoom(room);
                }
              });
            }
          });
          break;
        case this.username !== null && room.hasPassword === false:
          this.openRoom(room);
          break;
        case this.username !== null && room.hasPassword === true:
          this.passRequired = true;
          this.submitPassword(passInput, room).then((r) => {
            if (r == "success") {
              this.openRoom(room);
            }
          });
          break;
        default:
      }
    },
    async submitPassword(passInput, room) {
      var result = await axios
        .get(
          `https://api.enter.hetnieuweinstituut.nl/rooms?id=${room.id}&password=${passInput}`
        )
        .then((res) => {
          if (res.data.length !== 0) {
            this.passRequired = false;
            // window.console.log("success");
            return "success";
          } else {
            // this.errorMessage = "Wrong Password";
            return "error";
          }
        });
      return result;
    },
    async submitUsername(username, room) {
      if (!username) {
        this.errorMessage = "You need a username";
        return "error";
      }
      this.$store.commit("setUsername", username);
      return "success";
    },
    async openRoom(room) {
      // generate a random string as user Hash
      this.$store.commit(
        "setUserHash",
        Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15)
      );
      this.$store.commit("authenticate", true);
      this.$router.push(`/entered/${room.slug}`)
    },
  },
};
</script>

<style scoped>

#auth {
  /* display:flex;
  justify-content: center; */
}

input {
  width:200px;
}

input, button {
  display:block;
  margin:5px auto;
}

button#back-to-list {
  position:absolute;
  margin:30px;
  bottom:0;
}

img {
  display:inline-block;
  height:0.7em;
}

#limit-notification {
  text-align:left;
  max-width:15em;
  padding:8px;
  border-radius:10px;
  margin: 10px auto;
  border: 1px solid black;
  background-color: #dbfcf0;
  word-break: auto;
  hyphens: manual;
}

</style>